// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "body {\n  background: #ddd;\n  color: #fff;\n  display: flex;\n  flex-direction: row;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
